/**
 * usePlans Hook
 *
 * One-time fetch of active subscription plans from Firestore.
 * Plans are admin-seeded and immutable at runtime — no live listener needed.
 * The SDK's persistentLocalCache provides offline support.
 */

import { getActivePlans } from "../services/planService";
import type { Plan } from "../types/plan";
import { useOneShotFetch } from "./useOneShotFetch";

/**
 * Hook to fetch active subscription plans once
 *
 * @returns Plans sorted by category (basic first, then advanced)
 */
export function usePlans() {
  const { data: plans, loading, error } = useOneShotFetch<Plan>(getActivePlans);

  return {
    plans,
    loading,
    error,
    listening: false,
  };
}
